import {h, Component, Fragment} from "preact";
import {route} from "preact-router";
import {TicketHeader, TicketBody, EndedTicketPopups} from "../mobile-pages/ticket-ltn.jsx";
import Page from "../../../services/page-data-feed"

import FullSite from "./full-site";

import * as M from "../desktop-templates/prematch-menu.jsx";
import * as T from "../desktop-templates/prematch-right-col.jsx";
import * as I from "../utils/icons";
import * as L from "../desktop-templates/live-general.jsx";

import MenuFull from "../desktop-components/menu-full.jsx";
import {MenuSportsOnly} from "../desktop-components/menu-sports-only.jsx";
import MenuTopleagues from "../desktop-components/menu-topleagues.jsx";
import MenuSearchEvent from "../desktop-components/menu-search-event.jsx";
import MenuBetServices from "../desktop-components/menu-bet-services.jsx";
import MenuTimeFilter from "../desktop-components/menu-time-filter.jsx";

import PrematchCarousel from "../desktop-components/prematch-carousel.jsx";

import PrematchLastMinute from "../desktop-components/prematch-last-minute.jsx";
import PrematchLiveEvents from "../desktop-components/prematch-live-events.jsx";
import PrematchTournamentSelector from "../desktop-components/prematch-tournament-selector.jsx";
import PrematchTournament from "../desktop-components/prematch-tournament.jsx";
import PrematchEvent from "../desktop-components/prematch-event.jsx";

import TicketCheckBet from "../desktop-components/ticket-check-bet.jsx";
import TicketLoadBet from "../desktop-components/ticket-load-bet.jsx";
import TicketFastBet from "../desktop-components/ticket-fast-bet.jsx";

import PrintOddsComponent from "../desktop-components/print-odds.jsx";


export default function PrintOdds() {
    return <FullSite><PrintOddsTemplate/></FullSite>;
}

export function PrintOddsTemplate() {
	return <div>
        <L.TopRowContainer>
            <L.ContainerLink>
                <L.TopPageLink href="/prematch">Sport Home</L.TopPageLink>
                <L.TopPageLink href="/live">Live</L.TopPageLink>
            </L.ContainerLink>
        </L.TopRowContainer>
        <div class="flex border-b border-b-harifzinc-950 bg-harifzinc-900 text-white">
            <div class="scrollbar-fancy w-72 flex-none overflow-y-scroll border-r border-r-harifzinc-950">
                <M.MenuRow>
                    <M.MenuTitleLabel>Sports Menu</M.MenuTitleLabel>
                    <M.MenuCollapseBtnHolder><I.AnglesLeft class="h-4"/></M.MenuCollapseBtnHolder>
                </M.MenuRow>
                <MenuSearchEvent />
                <MenuTimeFilter />
                <MenuTopleagues callback={item => {
                    Page.openTournaments([item.id]);
                    route("/prematch")
                }}/>
                <a class="flex h-8 items-center border-b border-b-harifzinc-950 bg-harifzinc-800 hover:bg-harifzinc-700 text-white"
                   href="/live">
                    <M.MenuTitleCenteredLabel><I.StopwatchRegular
                        class="h-3 mr-1"/><span>IN-PLAY</span></M.MenuTitleCenteredLabel>
                </a>
                <MenuFull onTournamentOpen={e => route("/prematch")} />
                <M.BlankSeparator/>
                {/*<EsportsMenu /><M.BlankSeparator />*/}
                <MenuBetServices/>
            </div>
            <div class="scrollbar-fancy min-w-0 grow overflow-y-scroll border-r border-r-harifzinc-950">
                {/*<PrematchTournamentSelector />*/}
                {/*<PrematchTournament />*/}
                {/*<PrematchEvent />*/}
                <PrintOddsComponent/>
            </div>
        </div>
    </div>
}